
import {VideoSliderPlayer} from "./Blocks/Slider/VideoSliderPlayer";
import {Utils} from "./Utils";

import './Blocks/Header/Header';
import './Blocks/Hero/Hero';
import './Blocks/Booking/Booking';
import './Blocks/StickyNavigation/StickyNavigation';

import './Blocks/TextBehindImage/ThePerks/ThePerks';
import './Blocks/TextBehindImage/TextBehindImage';

import './Blocks/Slider/ImageGallerySlider';

import './Blocks/Slider/TinySlider/PerksGallerySlider';

import './Blocks/OurLocation/OurLocation';

import './Blocks/EventList/EventList';

import './Modals/StreetviewModal';

try {
    jQuery(document).ready(() => {
        jQuery('#footer_back_to_top').click(function () {
            jQuery('html, body').animate({
                scrollTop: 0
            }, 'slow');
        });
    });
} catch (e) {
    document.getElementById('footer_back_to_top').addEventListener('click', (e) => {
        window.scrollTo({ top: 0, behavior: 'smooth', block: 'center' })
    })
}

if ( typeof window.ovolo === 'undefined' ) {
    window.ovolo = {};
}

window.ovolo.utils = new Utils();

window.ovolo.videoSliderPlayer = new VideoSliderPlayer();
ovolo.videoSliderPlayer.init();
